import { Badge, Button, Spinner, Table } from "react-bootstrap";

function formatCurrency(value) {
  const amount = Number(value) || 0;
  return amount.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function formatDate(value) {
  if (!value) return "—";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [year, month, day] = value.slice(0, 10).split("-");
    return `${day}/${month}/${year}`;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("pt-BR");
}

function getExpenseStatus(expense) {
  if (expense.confirmed_date) {
    return { label: "Paga", bg: "success" };
  }

  const due = expense.due_date ? new Date(expense.due_date) : null;
  if (due && !Number.isNaN(due.getTime())) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);
    if (due < today) {
      return { label: "Atrasada", bg: "danger" };
    }
  }

  return { label: "Em aberto", bg: "secondary" };
}

export default function ExpensesTable({
  isFetching,
  expenses,
  onEdit,
  onDelete,
  onMarkPaid,
  isDeleting,
}) {
  if (isFetching) {
    return (
      <div className="d-flex justify-content-center m-5">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  if (!expenses?.length) {
    return (
      <p className="text-muted mb-0">Nenhuma despesa cadastrada.</p>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Descrição</th>
            <th>Categoria</th>
            <th>Valor</th>
            <th>Vencimento</th>
            <th>Status</th>
            <th style={{ width: 160 }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {expenses.map((expense) => {
            const status = getExpenseStatus(expense);
            return (
              <tr key={expense.id}>
                <td>{expense.description || "—"}</td>
                <td>{expense.category || "—"}</td>
                <td>{formatCurrency(expense.value)}</td>
                <td>{formatDate(expense.due_date)}</td>
                <td>
                  <Badge bg={status.bg}>{status.label}</Badge>
                </td>
                <td>
                  <div className="d-flex gap-1 flex-wrap">
                    {!expense.confirmed_date && (
                      <Button
                        size="sm"
                        variant="outline-success"
                        title="Marcar como paga"
                        onClick={() => onMarkPaid?.(expense)}
                      >
                        <i className="bi bi-check2-circle" />
                      </Button>
                    )}
                    <Button
                      size="sm"
                      variant="outline-primary"
                      title="Editar"
                      onClick={() => onEdit?.(expense)}
                    >
                      <i className="bi bi-pencil" />
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      title="Excluir"
                      disabled={isDeleting}
                      onClick={() => onDelete?.(expense)}
                    >
                      <i className="bi bi-trash" />
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
